import {
  colorTokens as libColorTokens,
  typographyTokens,
  spacingTokens,
  withMedia
} from '@make-software/tg-mini-app-ui';

export const colorTokens = {
  ...libColorTokens,
  // Casper primary action colour (buttons, links, checkboxes, accents)
  mainGreen: '#FB6F6A',
  // Text on filled/coloured button backgrounds → white
  mainDark: libColorTokens.contentOnFill,
  // Casper-app-specific tokens
  backgroundSecondary: '#0F1117',

  goldIconColor: '#F1BF0B',

  contentGreen: '#31DE91',
  mainOrange: '#FF4100',
  successGreen: '#5BFFE1',
  connectedAccent: '#98F7D3',
  darkestBg: '#0A0911',
  successCheck: '#29F746',
  errorText: '#FF6B6B',
  secondaryText: '#C0C7DC',
  mainRed: '#FB6F6A',
  mainGold: '#FF9F1C',
  darkBlue: '#242941',

  filledBtn: '#FB6F6A',
  filledBtnHover: '#F5615B',
  filledBtnDisabled: '#30313B',
  filledBtnDisabledText: '#64666B',
};

const fansTypographyTokens = {
  ...typographyTokens,
  fontFamily: {
    sans: 'Inter, sans-serif',
    display: "'JetBrains Mono', monospace",
    mono: "'JetBrains Mono', monospace"
  },
};
export const casperTheme = {
  withMedia,
  colors: colorTokens,
  typography: fansTypographyTokens,
  tokens: spacingTokens
};
